/* eslint-disable @angular-eslint/prefer-inject */
import { AsnLineDataService } from '../infrastructure/asn-lines/asn-line.data.service';
import {
    AsnLineCreate,
    AsnLineDto,
    AsnLineRead,
    AsnLineSearchParams,
} from '../entities/asn-line.dto';
import { AsnLineStore } from '../infrastructure/asn-lines/asn-line.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { AsnLineMapper } from '../infrastructure/asn-lines/asn-line.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes } from '@pf/shared-common';

@Injectable()
export class AsnLineFacade extends AbstractManageEntityFacade<
    AsnLineDto,
    AsnLineRead,
    AsnLineCreate,
    AsnLineSearchParams
> {
    nameField: keyof AsnLineDto = 'lineNumber';

    constructor(
        dataService: AsnLineDataService,
        store: AsnLineStore,
        mapper: AsnLineMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    protected override getParentId(asnLine: AsnLineDto): string | undefined {
        return asnLine.asnHeaderId || undefined;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof AsnLineDto, string>> {
        return { lineNumber: searchText };
    }
}
